import { FC } from 'react'

import { getFormattedDateTime } from '@/utils/datetime'

type Props = {
  dateStart: string
  dateEnd: string
}

const ContentBlockDateRange: FC<Props> = ({ dateStart, dateEnd }) => (
  <div className="flex gap-[120px]">
    <div className="flex flex-col gap-4">
      <p className="mb-4 font-bold text-grey-90 text-16">Действует с:</p>
      <p className="font-pro text-16">{getFormattedDateTime(dateStart)}</p>
    </div>

    <div className="flex flex-col gap-4">
      <p className="mb-4 font-bold text-grey-90 text-16">Действует до:</p>
      <p className="font-pro text-16">{getFormattedDateTime(dateEnd)}</p>
    </div>
  </div>
)

export default ContentBlockDateRange
